var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$router.currentRoute.path == '/' + _vm.role + '/secretariat/outbox')?_c('Letters',{attrs:{"letters":_vm.letters,"type":'outbox',"isLoaded":_vm.isLoaded},on:{"save":_vm.save,"removeSave":_vm.removeSave,"archive":_vm.archive,"removeArchive":_vm.removeArchive,"viewLetter":_vm.viewLetter}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }